import React ,{useRef} from "react";
import { Link } from "react-router-dom";
import { ServiceData } from "../data";
 import { gsap } from "gsap";
  import { useGSAP } from "@gsap/react";
  import { ScrollTrigger, SplitText } from "gsap/all";
  gsap.registerPlugin(ScrollTrigger, SplitText);
const ServiceInnerDetails = ({ servicedata }) => {

  const container = useRef(null);
 useGSAP(() => {
  gsap.utils.toArray(".service_pageheading_animation").forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      y: 100,
      duration: 0.8,
      scrollTrigger: {
        trigger: el,
        start: "top 87%",
        once: true,
        marker: true,
      },
    });
  });

  ScrollTrigger.refresh();
}, {
  scope: container,
  dependencies: [servicedata],
  revertOnUpdate: true,
 });
  const container2 = useRef();
 
 
   useGSAP(
     () => {
 
  
       const tl = gsap.timeline({
         scrollTrigger: {
           trigger: container2.current,
           start: "top+=250 bottom",
           end: "bottom",
           // markers: true
         },
       });
       tl
         .fromTo(
           ".relatedService_animation",
           { opacity: 0, y: 80 },
           {
             opacity: 1,
             y: 0,
             duration: 0.8,
             
           },
         )
       return () => {
         tl.kill();
       };
     },
     { scope: container2 },
   );
  return (
    <section className="space">
      <div className="container" ref={container}>
        <div className="row gx-30">
          <div className="col-xxl-8 col-lg-7">
            <div className="page-thumb mb-50">
             {servicedata.mainImg &&  <img src={servicedata.mainImg} alt="img" className="service_pageheading_animation"/>}
            </div>

            {/* <h3 className="page-title mt-40 mb-20">
           {servicedata.title}
            </h3>
             {servicedata.des && <p className="mb-50" dangerouslySetInnerHTML={{__html: servicedata.des}}>
            
            </p>}  */}
            {/* <div className="checklist style6 mt-40 mb-60">
                            <ul>
                                <li>
                                    <i className="fas fa-check-circle" />
                                    Navigate the Path to Success Achieve Your Business Goals with
                                    Confidenc
                                </li>
                                <li>
                                    <i className="fas fa-check-circle" />A business consultant is a
                                    professional who provides expert
                                </li>
                                <li>
                                    <i className="fas fa-check-circle" />
                                    Guidance to businesses on various aspects such as management
                                </li>
                            </ul>
            </div> */}

            {servicedata.featrued.map((item, index) => {
              return (
                <div key={index} className="mb-50 service_pageheading_animation">
                  <h3 className="page-title mb-20">
                   {item.title}
                  </h3>
                  {item.img && <img className="mb-30"
                    src={item.img}
                    alt="img"
                  />} 
                  <p className="" dangerouslySetInnerHTML={{__html: item.des}}>
                  </p>
                  {item.listData.length > 0 && <ul className="mb-30">
                    {item.listData.map((i , n)=>(
                      <li key={n} dangerouslySetInnerHTML={{__html: i}}></li>
                    ))}
                    </ul>}
            
                </div>
              );
            })}
          </div>
          <div className="col-xxl-4 col-lg-5 " ref={container2}>
            <aside className="sidebar-area relatedService_animation">
              <div className="widget widget_categories widget_service-categories">
                <ul>
                  {ServiceData.map((item,index)=>{
                    return(
                       <li>
                        <Link to={item.btnLink}>{item.title}</Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceInnerDetails;
